import { BASE_URL } from "../config";
import { axiosInstance } from "../providers/AxiosProvider";

export function fetchOneStudent(studentId) {
  return axiosInstance.get(`${BASE_URL}/api/students/${studentId}`);
}

export function fetchAllStudents() {
  return axiosInstance.get(`${BASE_URL}/api/students`);
}

export function createStudent(body) {
  return axiosInstance.post(`${BASE_URL}/api/students`, body);
}

export function patchStudent(studentId, body) {
  return axiosInstance.patch(`${BASE_URL}/api/students/${studentId}`, body);
}

export function deleteStudent(studentId) {
  return axiosInstance.delete(`${BASE_URL}/api/students/${studentId}`);
}
